import React from 'react';

import { Disclaimer } from './Disclaimer';
import './DisclaimersRow.css';

export const DisclaimersRow = ({ LOGO_DISCLAIMER, RATES_DISCLAIMER }) => {
  return (
    <div className="disclaimers-wrapper">
      <Disclaimer {...LOGO_DISCLAIMER} />
      <Disclaimer {...RATES_DISCLAIMER} />
    </div>
  );
};
